export const indicator = {
  "indicator.set": "indicator.set",
  "indicator.delete": "indicator.delete",
  "indicator.restore": "indicator.restore",
  "indicator.values.upload": "indicator.values.upload",
  "indicator.upload.accept": "indicator.upload.accept",
  "indicator.upload.reject": "indicator.upload.reject",
  "indicator.get": "indicator.get",
  "indicator.uploadLog.get": "indicator.uploadLog.get",
  "indicator.values.download": "indicator.values.download",
  "indicator.subscribe.newUploadDraft": "indicator.subscribe.newUploadDraft",
  "indicator.subscribe.reportReady": "indicator.subscribe.reportReady",
} as const;
